import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";
import { deleteDistributionChannel } from "../../../../../actions/Utilities/DistributionChannel";

const useDeleteDistributionChannel = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation((ids) => deleteDistributionChannel(ids), {
    onSuccess: () => {
      queryClient.invalidateQueries(["GetDistributionChannelList"]);
      toast.fire(
        "Success",
        "Distribution Channel has been deactivated successfully",
        "success"
      );
    },
    onError: () => {
      toast.fire(
        "Failed",
        "Server Error: Cannot deactivate Distribution Channel",
        "error"
      );
    },
  });

  return mutate;
};
export default useDeleteDistributionChannel;
